import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@volca/ui/components/ui/stack";
import { ConfidenceLabel, StFilingTargetLink } from "@/accounts-payable/common";
import type { ApReceipt } from "@/accounts-payable/types";

export const jobCol: ColumnDef<ApReceipt> = {
  id: "job",
  header: "Matched job",
  meta: { size: "150px" },
  cell: ({ row }) => {
    const { st_job_external_id, st_project_external_id, job_match_confidence } =
      row.original;
    if (!st_job_external_id && !st_project_external_id)
      return <span className="text-subtle">–</span>;
    return (
      <Stack gap={1} align="start">
        <StFilingTargetLink
          document={row.original}
          documentType="receipt"
          short
        />
        {job_match_confidence != null && (
          <ConfidenceLabel value={job_match_confidence} />
        )}
      </Stack>
    );
  },
};
